import { Autocomplete, Box, TextField } from "@mui/material";
import Typography from "@mui/material/Typography";
import SendIcon from "@mui/icons-material/Send";
import { countries } from "../../utils/countryList";
import LoadingButton from "@mui/lab/LoadingButton";
import PhoneInput from "react-phone-number-input";
import React, { useEffect, useState } from "react";
import "react-phone-number-input/style.css";
import "./contactUsForm.css";
import { useDispatch, useSelector } from "react-redux";
import { contactUsFront } from "../../reduxToolkit/features/miscFront";
import EmailVerificationDialog from "../EmailVerificationDialog";
import { emailVerify } from "../../reduxToolkit/features/auth";
import { colors, radii } from "../../theme/designTokens";

const fieldSx = {
  mb: 2,
  "& .MuiOutlinedInput-root": {
    borderRadius: radii.md,
    "& fieldset": { borderColor: colors.line },
    "&:hover fieldset": { borderColor: colors.primary },
    "&.Mui-focused fieldset": { borderColor: colors.primary },
  },
};

export default function ContactUsForm() {
  const dispatch = useDispatch();
  const [phone, setPhone] = useState();
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    country: "",
    whatsApp: "",
    weChat: "",
    skype: "",
    telegram: "",
    twitter: "",
    fb: "",
    msg: "",
  });

  // Store
  const { webSettings } = useSelector((state) => state.webSettings);
  const { emailResponse } = useSelector((state) => state.auth);

  const [emailVerified, setEmailVerified] = useState(false);
  const [countryLoading, setCountryLoading] = useState(false);
  const [verifyEmailLoading, setVerifyEmailLoading] = useState(false);
  const [vCode, setVCode] = useState("");
  const [verifyDlg, setVerifyDlg] = useState(false);
  const [verifyCodeInput, setVerifyCodeInput] = useState("");

  // Count down
  const [countDownStart, setCountDownStart] = React.useState("");

  // ! Lang Id Assign
  const [langId, setLangId] = useState("");
  const { activeLangFront } = useSelector((state) => state.miscFront);
  // Set Language
  useEffect(() => {
    if (activeLangFront) setLangId(activeLangFront._id);
  }, [activeLangFront]);
  // ! Lang Id Assign

  const handleVerifyEmail = () => {
    setCountDownStart(
      new Date().getTime() + (webSettings.verificationInterval || 1) * 60000
    );
    let v = Math.floor(Math.random() * (999999 - 100000 + 1) + 100000);
    setVCode(v);
    v = v * 3875412698;
    dispatch(emailVerify({ v, email: formData.email, langId }));
    setVerifyEmailLoading(true);
  };

  // Function
  const handleSubmit = (e) => {
    e.preventDefault();
    handleVerifyEmail();
  };

  const contactUsFunc = () => {
    setCountryLoading(true);
    setEmailVerified(false);
    dispatch(
      contactUsFront({
        ...formData,
        phone,
        browserInfo: navigator.userAgent,
        langId,
      })
    );
    setTimeout(() => {
      setFormData({
        fullName: "",
        email: "",
        country: "",
        whatsApp: "",
        weChat: "",
        skype: "",
        telegram: "",
        twitter: "",
        fb: "",
        msg: "",
      });
      setPhone("");

      setCountryLoading(false);
    }, 1000);
  };

  useEffect(() => {
    let obj = { ...formData };
    obj.phone = phone;
    setFormData(obj);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [phone]);

  // Check Verification Code
  useEffect(() => {
    setVerifyEmailLoading(true);
    if (vCode === Number(verifyCodeInput)) {
      setVerifyDlg(false);
      setEmailVerified(true);
      setVerifyCodeInput("");
    }
    setVerifyEmailLoading(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [verifyCodeInput]);

  useEffect(() => {
    if (emailVerified) contactUsFunc();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emailVerified]);

  // check Email Response
  useEffect(() => {
    if (emailResponse.message) {
      if (!emailResponse.failed) setVerifyDlg(true);
      setVerifyEmailLoading(false);
    }
  }, [emailResponse]);

  //! Translate
  // Store
  const { langArrFromClientSideFrontend } = useSelector(
    (state) => state.miscFront
  );
  const translateFront = (String) => {
    let translation = "";
    if (
      langArrFromClientSideFrontend &&
      langArrFromClientSideFrontend.length > 0
    ) {
      const T = langArrFromClientSideFrontend.find((l) => l.title === String);
      if (T && T.value) {
        let obj = { ...T };
        if (T.value === "") obj.value = T.title;
        translation = T.value;
      }
    }
    return translation;
  };
  //! Translate

  return (
    <Box>
      <TextField
        label={translateFront("Full Name")}
        variant="outlined"
        required
        fullWidth
        sx={fieldSx}
        value={formData.fullName}
        onChange={(e) => {
          let obj = { ...formData };
          obj.fullName = e.target.value;
          setFormData(obj);
        }}
      />
      <TextField
        required
        label={translateFront("Email")}
        type="email"
        variant="outlined"
        fullWidth
        sx={fieldSx}
        value={formData.email}
        onChange={(e) => {
          let obj = { ...formData };
          obj.email = e.target.value;
          setFormData(obj);
        }}
      />
      {!countryLoading && (
        <Autocomplete
          id="country-select"
          options={countries}
          autoHighlight
          getOptionLabel={(option) => option.label}
          onChange={(e, newValue) => {
            let obj = { ...formData };
            obj.country = newValue.label;
            setFormData(obj);
          }}
          renderOption={(props, option) => (
            <Box
              component="li"
              sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
              {...props}
            >
              <img
                loading="lazy"
                width="20"
                src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                alt=""
              />
              {option.label}
            </Box>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              required
              sx={fieldSx}
              label={translateFront("Choose a country")}
              variant="outlined"
              inputProps={{
                ...params.inputProps,
                autoComplete: "new-country",
              }}
            />
          )}
        />
      )}
      <Typography sx={{ fontSize: 13, fontWeight: 600, color: colors.ink2, mb: 0.75 }}>
        {translateFront("Phone")} *
      </Typography>
      <Box sx={{ mb: 2 }}>
        <PhoneInput
          placeholder={translateFront("Enter Phone Number")}
          international
          defaultCountry="US"
          value={phone}
          onChange={setPhone}
        />
      </Box>
      <TextField
        required
        label={translateFront("Message")}
        multiline
        minRows={4}
        type="text"
        variant="outlined"
        fullWidth
        sx={fieldSx}
        value={formData.msg}
        onChange={(e) => {
          let obj = { ...formData };
          obj.msg = e.target.value;
          setFormData(obj);
        }}
        helperText={
          <Typography align="right" sx={{ fontSize: 12, color: colors.ink3 }}>
            {formData.msg.length}/2000
          </Typography>
        }
      />
      <LoadingButton
        variant="contained"
        fullWidth
        onClick={handleSubmit}
        loading={verifyEmailLoading}
        disabled={
          !(
            formData.fullName !== "" &&
            formData.email !== "" &&
            formData.country !== "" &&
            formData.msg !== "" &&
            phone !== ""
          )
        }
        endIcon={<SendIcon />}
        sx={{
          bgcolor: colors.accent,
          borderRadius: radii.md,
          textTransform: "none",
          fontWeight: 700,
          py: 1.25,
          boxShadow: "none",
          "&:hover": { bgcolor: "#C94F21", boxShadow: "none" },
        }}
      >
        {translateFront("Ask Away")}
      </LoadingButton>

      {verifyDlg && (
        <EmailVerificationDialog
          verifyDlg={verifyDlg}
          setVerifyDlg={setVerifyDlg}
          verifyCodeInput={verifyCodeInput}
          setVerifyCodeInput={setVerifyCodeInput}
          countDownStart={countDownStart}
          setCountDownStart={setCountDownStart}
          logic={handleVerifyEmail}
        />
      )}
    </Box>
  );
}
